import { create } from 'zustand';
import { apiFetch } from '../api';

const useSubjectStore = create((set, get) => ({
  subjects: [],
  loading: false,
  error: null,

  async fetchSubjects() {
    set({ loading: true, error: null });
    try {
      const data = await apiFetch('/subjects');
      set({ subjects: data, loading: false });
    } catch (e) {
      set({ error: e.message, loading: false });
    }
  },

  async addSubject({ name }) {
    set({ loading: true, error: null });
    try {
      const { token } = require('./adminAuthStore').default.getState();
      const data = await apiFetch('/subjects', {
        method: 'POST',
        body: { name },
        token,
      });
      // После добавления обновляем список
      await get().fetchSubjects();
      set({ loading: false });
      return data;
    } catch (e) {
      set({ error: e.message, loading: false });
      throw e;
    }
  },

  async removeSubject(id) {
    set({ loading: true, error: null });
    try {
      const { token } = require('./adminAuthStore').default.getState();
      await apiFetch(`/subjects/${id}`, {
        method: 'DELETE',
        token,
      });
      await get().fetchSubjects();
      set({ loading: false });
    } catch (e) {
      set({ error: e.message, loading: false });
      throw e;
    }
  },
}));

export default useSubjectStore; 